import { Icon } from '@procurify/ui'

import { useFormatMedia } from '@webapp/core/hooks/useFormatMedia'
import { ConversationOrderSummaryThumbnailStyled } from './styles/ConversationOrderSummaryThumbnailStyled'

export interface IConversationOrderSummaryThumbnailProps {
  img?: string
}

export const ConversationOrderSummaryThumbnail = ({
  img,
}: IConversationOrderSummaryThumbnailProps) => {
  const formatMedia = useFormatMedia()

  return (
    <ConversationOrderSummaryThumbnailStyled>
      {img ? (
        <img src={formatMedia(img)} alt='' className='fs-mask' />
      ) : (
        <Icon icon='gallery' size={20} color='darkGrey' />
      )}
    </ConversationOrderSummaryThumbnailStyled>
  )
}
